export default __webpack_public_path__ + "00fa0acdbd80a2da84dc385e240932e0.png";